var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", [_vm._v("Vendor Upload")]),
    _vm._v(" "),
    !_vm.vendor
      ? _c("div", [
          _c(
            "a",
            {
              staticStyle: { color: "#375", "text-decoration": "underline" },
              attrs: { href: "javascript:;" },
              on: { click: _vm.initiate },
            },
            [_vm._v("Enable vendor pathway")]
          ),
        ])
      : _c(
          "div",
          [
            _c(
              "a",
              {
                staticStyle: { color: "#375", "text-decoration": "underline" },
                attrs: { href: "javascript:;" },
                on: { click: _vm.initiate },
              },
              [_vm._v("Enable vendor pathway")]
            ),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _c("b", [_vm._v("Zip file:")]),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: "/api/vendors/" + _vm.articleId + "/zip" } },
                  [_vm._v(_vm._s(_vm.articleId) + ".zip")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Status: ")]),
                _vm._v(" "),
                _vm.vendor.uploaded_at
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-success",
                        staticStyle: { "font-size": "14px" },
                      },
                      [_vm._v("Sent to vendor")]
                    )
                  : _c(
                      "span",
                      {
                        staticClass: "badge badge-danger",
                        staticStyle: { "font-size": "14px" },
                      },
                      [_vm._v("Not yet sent to vendor.")]
                    ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Uploaded At: ")]),
                _vm._v(" "),
                _vm.vendor.uploaded_at
                  ? _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        staticStyle: { "font-size": "14px" },
                      },
                      [_vm._v(_vm._s(_vm.vendor.uploaded_at))]
                    )
                  : _c("span", [_vm._v("--/--")]),
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Document")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.data.document,
                        expression: "vendor.data.document",
                      },
                    ],
                    staticStyle: { width: "45%" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.vendor.data,
                          "document",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Please select a document"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.documents, function (document) {
                      return _c(
                        "option",
                        {
                          domProps: {
                            value: {
                              id: document.file_id,
                              revision: document.revision,
                            },
                          },
                        },
                        [_vm._v(_vm._s(document.original_file_name))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Copyediting Level")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.data.level,
                        expression: "vendor.data.level",
                      },
                    ],
                    staticStyle: { width: "15%" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.vendor.data,
                          "level",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Please select a copyediting level"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("0 (no copyedit)"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [_vm._v("3")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Notes")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.vendor.data.notes,
                      expression: "vendor.data.notes",
                    },
                  ],
                  attrs: { name: "name", rows: "16", cols: "80" },
                  domProps: { value: _vm.vendor.data.notes },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.vendor.data, "notes", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group float-right" }, [
                _c(
                  "button",
                  {
                    class: { deactive: _vm.vendor.uploaded_at },
                    on: { click: _vm.save },
                  },
                  [
                    _vm._v(
                      "\n                    Save Configuration\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { deactive: _vm.vendor.uploaded_at },
                    on: { click: _vm.send },
                  },
                  [
                    _vm._v(
                      "\n                    Send to Vendor\n                "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._l(_vm.vendor.results, function (result, resultIndex) {
              return _c("div", [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(
                      "Response from Transforma #" +
                        _vm._s(resultIndex + 1) +
                        ":\n                    "
                    ),
                    _c("small", [
                      _vm._v("("),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://" +
                              result.bucket +
                              ".s3.us-east-2.amazonaws.com/" +
                              result.key,
                            target: "_blank",
                          },
                        },
                        [_vm._v("view package")]
                      ),
                      _vm._v(")"),
                    ]),
                  ]),
                  _vm._v(" "),
                  result.status == "received"
                    ? _c("div", [
                        _c("label", [_vm._v("Notes (optional)")]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "file" },
                          on: { change: _vm.handleUpload },
                        }),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.note,
                              expression: "note",
                            },
                          ],
                          domProps: { value: _vm.note },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.note = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.action("rejected", result)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Reject\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.action("accepted", result)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Accept and Sync\n                    "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  result.status == "rejected"
                    ? _c("div", [
                        _vm._v(
                          "\n                    This package was rejected.\n\n                    "
                        ),
                        result.notes
                          ? _c("p", [_c("q", [_vm._v(_vm._s(result.notes))])])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  result.status == "accepted"
                    ? _c("div", [
                        _vm._v(
                          "\n                    This package was accepted.\n\n                    "
                        ),
                        result.notes
                          ? _c("p", [_c("q", [_vm._v(_vm._s(result.notes))])])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  result.status == "revised"
                    ? _c("div", [
                        _vm._v(
                          "\n                    (revision) This package contained an updated version of\n                    the PDF after a minor XML modification was sent.\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("Vendor")]),
      _vm._v(" "),
      _c("p", [_vm._v("\n                    Transforma\n                ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }